import { IOmniaHttpService } from "../types"
import { IOmniaUser } from "../user"
import { IUsersApi } from "./types"

/** @internal */
export class UsersApi implements IUsersApi {

    static $inject = ["OmniaHttpService"]

    constructor(private http: IOmniaHttpService) {
    }

    saveUser(user: IOmniaUser): ng.IPromise<IOmniaUser> {
        const url = "/api/user/v1/user"
        return this.http.post(url, user).then(r => r.data)
    }

    resetPassword(password: string): ng.IPromise<any> {
        const url = "/api/user/v1/password/change"
        return this.http.post(url, { Password: password })
    }

    acceptTcs(version: string, send: boolean): PromiseLike<boolean> {
        const url = `/api/user/v1/tcs/accept?version=${version}&send=${send}`
        return this.http.post(url).then(() => true).catch(() => false)
    }
}
